// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Navigation Bar */
.navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 2rem;
  background: rgba(0, 0, 0, 0.95);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(0, 163, 255, 0.2);
  position: sticky;
  top: 0;
  z-index: 1000;
  box-shadow: 0 4px 20px rgba(0, 163, 255, 0.1);
}

.nav-logo {
  position: relative;
  margin-left: 50px;
}

.logo-link {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  text-decoration: none;
}

.logo-text {
  font-size: 1.5rem;
  font-weight: 700;
  background: #ffffff;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  letter-spacing: 1px;
}

.logo-pulse {
  width: 8px;
  height: 8px;
  background: #00a3ff;
  border-radius: 50%;
  animation: pulse 2s infinite;
  box-shadow: 0 0 10px #00a3ff;
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.5);
    opacity: 0.5;
  }
}

.nav-menu {
  display: flex;
  list-style: none;
  margin-right: 40px;
  gap: 2rem;
  padding: 0;
}

.nav-menu li {
  position: relative;
}

.nav-menu a {
  color: #b0b0b0;
  text-decoration: none;
  font-weight: 500;
  font-size: 1rem;
  transition: color 0.3s ease;
  padding: 0.5rem 0;
  display: inline-block;
}

.nav-menu a:hover {
  color: #00a3ff;
}

.nav-menu li.active a {
  color: #00a3ff;
}

.nav-menu li::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 2px;
  background: linear-gradient(90deg, #00a3ff 0%, #ffffff 100%);
  transition: width 0.3s ease;
}

.nav-menu li.active::after,
.nav-menu li:hover::after {
  width: 100%;
}

.nav-toggle {
  display: none;
  background: transparent;
  border: 1px solid rgba(0, 163, 255, 0.4);
  padding: 0.5rem;
  border-radius: 8px;
  cursor: pointer;
}

.nav-toggle-bar {
  display: block;
  width: 22px;
  height: 2px;
  background: #ffffff;
  margin: 5px 0;
  transition: transform 0.3s ease, opacity 0.3s ease;
}

.nav-toggle.open .nav-toggle-bar:nth-child(1) {
  transform: translateY(7px) rotate(45deg);
}

.nav-toggle.open .nav-toggle-bar:nth-child(2) {
  opacity: 0;
}

.nav-toggle.open .nav-toggle-bar:nth-child(3) {
  transform: translateY(-7px) rotate(-45deg);
}

/* Responsive Design */
@media (max-width: 768px) {
  .navbar {
    padding: 1rem;
    position: sticky;
  }

  .nav-menu {
    position: absolute;
    top: 100%;
    right: 1rem;
    left: 1rem;
    flex-direction: column;
    gap: 0.5rem;
    margin: 0;
    padding: 1rem;
    background: rgba(0, 0, 0, 0.98);
    border: 1px solid rgba(0, 163, 255, 0.2);
    border-radius: 12px;
    box-shadow: 0 16px 30px rgba(0, 0, 0, 0.35);
    opacity: 0;
    pointer-events: none;
    transform: translateY(-10px);
    transition: opacity 0.2s ease, transform 0.2s ease;
  }

  .nav-menu.open {
    opacity: 1;
    pointer-events: auto;
    transform: translateY(0);
  }

  .nav-menu li::after {
    display: none;
  }

  .nav-menu a {
    font-size: 0.9rem;
    padding: 0.4rem 0;
  }

  .nav-toggle {
    display: inline-flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .nav-logo {
    margin-left: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/navbar/Navbar.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,+BAA+B;EAC/B,2BAA2B;EAC3B,+CAA+C;EAC/C,gBAAgB;EAChB,MAAM;EACN,aAAa;EACb,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,qBAAqB;IACrB,YAAY;EACd;AACF;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,2BAA2B;EAC3B,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,4DAA4D;EAC5D,2BAA2B;AAC7B;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,wCAAwC;EACxC,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,kDAAkD;AACpD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,UAAU;IACV,sBAAsB;IACtB,WAAW;IACX,SAAS;IACT,aAAa;IACb,+BAA+B;IAC/B,wCAAwC;IACxC,mBAAmB;IACnB,2CAA2C;IAC3C,UAAU;IACV,oBAAoB;IACpB,4BAA4B;IAC5B,kDAAkD;EACpD;;EAEA;IACE,UAAU;IACV,oBAAoB;IACpB,wBAAwB;EAC1B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;IACpB,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":["/* Navigation Bar */\n.navbar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1rem 2rem;\n  background: rgba(0, 0, 0, 0.95);\n  backdrop-filter: blur(10px);\n  border-bottom: 1px solid rgba(0, 163, 255, 0.2);\n  position: sticky;\n  top: 0;\n  z-index: 1000;\n  box-shadow: 0 4px 20px rgba(0, 163, 255, 0.1);\n}\n\n.nav-logo {\n  position: relative;\n  margin-left: 50px;\n}\n\n.logo-link {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  text-decoration: none;\n}\n\n.logo-text {\n  font-size: 1.5rem;\n  font-weight: 700;\n  background: #ffffff;\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  letter-spacing: 1px;\n}\n\n.logo-pulse {\n  width: 8px;\n  height: 8px;\n  background: #00a3ff;\n  border-radius: 50%;\n  animation: pulse 2s infinite;\n  box-shadow: 0 0 10px #00a3ff;\n}\n\n@keyframes pulse {\n  0%, 100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n  50% {\n    transform: scale(1.5);\n    opacity: 0.5;\n  }\n}\n\n.nav-menu {\n  display: flex;\n  list-style: none;\n  margin-right: 40px;\n  gap: 2rem;\n  padding: 0;\n}\n\n.nav-menu li {\n  position: relative;\n}\n\n.nav-menu a {\n  color: #b0b0b0;\n  text-decoration: none;\n  font-weight: 500;\n  font-size: 1rem;\n  transition: color 0.3s ease;\n  padding: 0.5rem 0;\n  display: inline-block;\n}\n\n.nav-menu a:hover {\n  color: #00a3ff;\n}\n\n.nav-menu li.active a {\n  color: #00a3ff;\n}\n\n.nav-menu li::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 0;\n  height: 2px;\n  background: linear-gradient(90deg, #00a3ff 0%, #ffffff 100%);\n  transition: width 0.3s ease;\n}\n\n.nav-menu li.active::after,\n.nav-menu li:hover::after {\n  width: 100%;\n}\n\n.nav-toggle {\n  display: none;\n  background: transparent;\n  border: 1px solid rgba(0, 163, 255, 0.4);\n  padding: 0.5rem;\n  border-radius: 8px;\n  cursor: pointer;\n}\n\n.nav-toggle-bar {\n  display: block;\n  width: 22px;\n  height: 2px;\n  background: #ffffff;\n  margin: 5px 0;\n  transition: transform 0.3s ease, opacity 0.3s ease;\n}\n\n.nav-toggle.open .nav-toggle-bar:nth-child(1) {\n  transform: translateY(7px) rotate(45deg);\n}\n\n.nav-toggle.open .nav-toggle-bar:nth-child(2) {\n  opacity: 0;\n}\n\n.nav-toggle.open .nav-toggle-bar:nth-child(3) {\n  transform: translateY(-7px) rotate(-45deg);\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .navbar {\n    padding: 1rem;\n    position: sticky;\n  }\n\n  .nav-menu {\n    position: absolute;\n    top: 100%;\n    right: 1rem;\n    left: 1rem;\n    flex-direction: column;\n    gap: 0.5rem;\n    margin: 0;\n    padding: 1rem;\n    background: rgba(0, 0, 0, 0.98);\n    border: 1px solid rgba(0, 163, 255, 0.2);\n    border-radius: 12px;\n    box-shadow: 0 16px 30px rgba(0, 0, 0, 0.35);\n    opacity: 0;\n    pointer-events: none;\n    transform: translateY(-10px);\n    transition: opacity 0.2s ease, transform 0.2s ease;\n  }\n\n  .nav-menu.open {\n    opacity: 1;\n    pointer-events: auto;\n    transform: translateY(0);\n  }\n\n  .nav-menu li::after {\n    display: none;\n  }\n\n  .nav-menu a {\n    font-size: 0.9rem;\n    padding: 0.4rem 0;\n  }\n\n  .nav-toggle {\n    display: inline-flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .nav-logo {\n    margin-left: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
